import moment from 'moment'
import 'moment/locale/ru'
import type { ShiftCellAssignment } from './ShiftScheduleGrid'
import { isPastScheduleDate } from './shiftScheduleLayout'

moment.locale('ru')

export interface EmployeeMonthStats {
	key: string
	label: string
	workedCount: number
	totalCount: number
	lastShift: ShiftCellAssignment | null
}

export const getMonthsInDateRange = (
	startDate: number,
	endDate: number,
): { key: string; label: string }[] => {
	const months: { key: string; label: string }[] = []
	const current = moment(startDate).startOf('month')
	const end = moment(endDate).startOf('month')

	while (current.isSameOrBefore(end)) {
		months.push({
			key: current.format('YYYY-MM'),
			label: current.format('MMMM'),
		})
		current.add(1, 'month')
	}

	return months
}

export const getEmployeeMonthStats = (
	assignments: ShiftCellAssignment[],
	monthKey: string,
): EmployeeMonthStats => {
	const monthAssignments = assignments.filter(
		item => moment(item.date).format('YYYY-MM') === monthKey,
	)
	const completed = monthAssignments.filter(item =>
		isPastScheduleDate(item.date),
	)
	const lastShift =
		completed.length > 0
			? [...completed].sort((a, b) => b.date - a.date)[0]
			: null

	return {
		key: monthKey,
		label: moment(monthKey, 'YYYY-MM').format('MMMM'),
		workedCount: completed.length,
		totalCount: monthAssignments.length,
		lastShift,
	}
}

export const splitEmployeeAssignments = (
	assignments: ShiftCellAssignment[],
) => {
	const completed: ShiftCellAssignment[] = []
	const planned: ShiftCellAssignment[] = []

	assignments.forEach(item => {
		if (isPastScheduleDate(item.date)) {
			completed.push(item)
		} else {
			planned.push(item)
		}
	})

	const sortByDate = (items: ShiftCellAssignment[]) =>
		[...items].sort((a, b) => a.date - b.date)

	return {
		completed: sortByDate(completed),
		planned: sortByDate(planned),
	}
}

export const groupAssignmentsByParlor = (
	assignments: ShiftCellAssignment[],
): [string, ShiftCellAssignment[]][] => {
	const map = new Map<string, ShiftCellAssignment[]>()

	assignments.forEach(item => {
		const list = map.get(item.parlorName) ?? []
		map.set(item.parlorName, [...list, item])
	})

	return Array.from(map.entries())
}
